// extracted by mini-css-extract-plugin
export default {"button":"Il-z","reviewSort":"Jl-z"};